import {createSelector} from '@reduxjs/toolkit'

const addressForServiceSelector = createSelector(
    [state => state.components,
    state => state.primaryAgencyApplication.application?.businessLicenceData],
    (components, appData) => {
        let address = { singleLineAddress : ""}
        if(appData && appData.serviceCivicAddress) {
            address = appData.serviceCivicAddress
        }
        return Object.assign({},
            components.addressForService,
            {serviceCivicAddress : address}
        )
    }
)

export const addressForServiceSelect = state => ({
    addressForService: addressForServiceSelector(state)
})

export function populateAddressForServiceDetails(addressForService) { 
    if(addressForService) { 
        return {
            "Street address" : addressForService.street ? addressForService.street : "",
            "City/Town" : addressForService.city ? addressForService.city : "",
            "Postal code" : addressForService.postalCode ? addressForService.postalCode : ""
        }
    }

    return {
        "Street address" : "",
        "City/Town" : "",
        "Postal code" : ""
    }
}